module.exports = __webpack_public_path__ + "img/pijltje-wit-rechts.81aeb83ae09ca3866bfdd50b6fc71d9c.svg";